import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import ServiceAppointmentSchedulerBlockData from '../../../Models/Content/ServiceAppointmentSchedulerBlockData';
import Main from './Main';

export default class ServiceAppointmentSchedulerBlock extends EpiComponent<ServiceAppointmentSchedulerBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['service-appointment-scheduler'];
    if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);

    return (
      <div className={cssClasses.join(" ")}>
        <Main iContent={this.props.data} context={this.getContext()} />
      </div>
    )
  }
}

